export const eurFixedExchangeVal = 1.95583;

export const calcEurFee = (fee) => {
  return fee / eurFixedExchangeVal;
};

export const calcBgnFee = (fee) => {
  return fee * eurFixedExchangeVal;
};
